import * as Sentry from '@sentry/react'

export const handleFetchErrorFunctional =
  function handleFetchErrorFunctional() {
    return (error: Error) => {
      console.error(error)
      Sentry.captureException(error)
    }
  }
